export default __webpack_public_path__ + "static/media/STL-re-appointment-of-independent-directos.89eeb090.pdf";